
export const zhCommon = {
  // 导航
  nav_home: '首页',
  nav_services: '服务方案',
  nav_cases: '成功案例',
  nav_about: '关于我们',
  nav_contact: '联系我们',
  nav_apply: '达人招募',
  nav_consult: '立即咨询',
  nav_articles: '最新资讯',

  // 公司信息
  company_name: 'Koluno',
  company_desc: '专注全球达人整合营销，连接品牌与创作者，实现可衡量的商业增长',
  
  // 首页英雄区
  hero_title: '全球达人',
  hero_title_highlight: '整合营销方案',
  hero_subtitle: 'Global Influencer Marketing Solutions',
  hero_description: '连接品牌与全球创作者，结合达人带货 + 广告放大 + 数据复盘，实现可衡量的增长',
  hero_brand_btn: '我是品牌方',
  hero_creator_btn: '我是达人',
  
  // 我们的价值
  value_title: '我们的价值',
  value_subtitle: '专业的整合营销服务，为品牌创造可衡量的商业价值',
  
  // 价值特性
  value_global_network: '全球达人网络',
  value_global_network_desc: '覆盖50+国家地区，200+优质达人资源，精准匹配品牌需求，快速启动合作项目',
  
  value_integrated_marketing: '整合营销方案',
  value_integrated_marketing_desc: '达人带货+广告投放+数据复盘，一站式服务，从策略制定到执行落地，全程专业支持',
  
  value_transparent_data: '透明数据与复盘',
  value_transparent_data_desc: '实时数据监控，详细效果报告，ROI清晰可见，持续优化投放策略，确保营销效果最大化',
  
  value_category_expertise: '品类经验与方法论',
  value_category_expertise_desc: '深耕各行业营销经验，成熟的方法论体系，针对不同品类制定专属策略，提升转化效率',
  
  value_fast_execution: '快速执行与灵活支持',
  value_fast_execution_desc: '24小时内响应需求，灵活的合作模式，专业团队全程跟进，确保项目按时高质量交付',

  // 服务方案
  services_title: '服务方案预览',
  services_subtitle: 'Services Preview',
  services_description: '三大核心服务，满足不同阶段的营销需求',
  
  service_influencer: '达人带货',
  service_influencer_en: 'Influencer Collaborations',
  service_influencer_desc: '按场景匹配达人，快速起量，包含选人、沟通、内容审核、上线跟踪',
  service_influencer_feature1: '精准达人匹配',
  service_influencer_feature2: '内容质量把控',
  service_influencer_feature3: '全程项目跟踪',
  service_influencer_feature4: '数据效果监控',
  
  service_amplification: '广告投放放大',
  service_amplification_en: 'Ad Amplification',
  service_amplification_desc: '达人内容授权投放，结合定向策略、预算分配，实现更高转化',
  service_amplification_feature1: '内容授权投放',
  service_amplification_feature2: '精准定向策略',
  service_amplification_feature3: '预算优化分配',
  service_amplification_feature4: '转化率提升',
  
  service_integrated: '一站式整合方案',
  service_integrated_en: 'One-Stop Integrated Plan',
  service_integrated_desc: '从策略到执行到数据复盘，全流程交付，明确KPI与里程碑',
  service_integrated_feature1: '全流程服务',
  service_integrated_feature2: '策略制定执行',
  service_integrated_feature3: '数据复盘优化',
  service_integrated_feature4: 'KPI目标管理',
  
  btn_learn_details: '了解详情',
  btn_view_full_services: '查看完整服务方案',
  
  // 成功案例
  cases_title: '成功案例预览',
  cases_subtitle: 'Case Studies Preview',
  cases_description: '真实案例见证，数据说话的营销效果',
  
  case_baby_category: '母婴品牌',
  case_baby_platform: '小红书',
  case_baby_title: '高端婴儿用品品牌全球推广',
  case_baby_desc: '通过精准达人匹配和内容策略，实现品牌在小红书平台的爆发式增长',
  
  case_beauty_category: '美妆品牌',
  case_beauty_platform: '抖音/TikTok',
  case_beauty_title: '国际美妆品牌跨境营销',
  case_beauty_desc: '结合达人带货和广告投放，在抖音和TikTok双平台实现突破性增长',
  
  case_smart_category: '生活用品',
  case_smart_platform: '跨境投放',
  case_smart_title: '智能家居产品全球市场拓展',
  case_smart_desc: '通过多平台整合营销，成功将智能家居产品推向15个国家市场',
  
  metric_exposure: '曝光量',
  metric_engagement: '互动率',
  metric_sales: '销量增长',
  metric_conversion: '转化率',
  metric_live_uv: '直播UV',
  metric_roas: 'ROAS',
  metric_followers: '粉丝增长',
  metric_countries: '覆盖国家',
  
  btn_view_more_cases: '查看更多成功案例',
  
  // 合作流程
  process_title: '合作流程',
  process_subtitle: 'How It Works',
  process_description: '标准化流程，专业化服务，确保每个项目都能达到预期效果',
  
  process_step1: '需求沟通',
  process_step1_en: 'Requirements Analysis',
  process_step1_desc: '深入了解品牌需求，明确营销目标，制定初步策略方向',
  process_step1_detail1: '品牌调研分析',
  process_step1_detail2: '目标受众定位',
  process_step1_detail3: '竞品策略研究',
  process_step1_detail4: '预算规划建议',
  
  process_step2: '策略与选人',
  process_step2_en: 'Strategy & Creator Selection',
  process_step2_desc: '制定详细营销策略，精准匹配优质达人资源',
  process_step2_detail1: '营销策略制定',
  process_step2_detail2: '达人精准匹配',
  process_step2_detail3: '内容创意规划',
  process_step2_detail4: '时间节点安排',
  
  process_step3: '执行与放大',
  process_step3_en: 'Execution & Amplification',
  process_step3_desc: '内容制作上线，广告投放放大，实时监控优化',
  process_step3_detail1: '内容制作监督',
  process_step3_detail2: '多平台同步发布',
  process_step3_detail3: '广告投放优化',
  process_step3_detail4: '实时数据监控',
  
  process_step4: '数据复盘',
  process_step4_en: 'Data Analysis & Review',
  process_step4_desc: '全面数据分析，效果复盘总结，持续优化策略',
  process_step4_detail1: '效果数据分析',
  process_step4_detail2: 'ROI计算报告',
  process_step4_detail3: '策略优化建议',
  process_step4_detail4: '下期规划制定',
  
  process_team_title: '专业团队，全程服务',
  process_team_desc: '我们的专业团队将在每个环节为您提供支持，确保项目顺利进行并达到预期效果',
  process_response_time: '24小时内响应',
  process_quality_guarantee: '质量保证',
  process_dedicated_service: '专属客服',
  process_continuous_optimization: '持续优化',
  
  // 联系我们
  contact_title: '联系我们',
  contact_description: '多种联系方式，专业团队为您提供全方位支持',
  contact_email_desc: '工作日24小时内回复',
  contact_telegram_desc: '即时沟通，快速响应',
  contact_wechat_desc: '专业客服团队在线',
  
  // 新增的快速响应承诺
  contact_promise_title: '快速响应承诺',
  contact_email_time: '24小时',
  contact_email_time_desc: '邮件响应时间',
  contact_instant_time: '2小时',
  contact_instant_time_desc: '即时消息响应',
  contact_matching_time: '48小时',
  contact_matching_time_desc: '合作匹配时间',
  
  // CTA区域
  cta_title: '准备好开始了吗？',
  cta_subtitle: 'Ready to get started?',
  cta_description: '立即联系我们，获取专属营销方案，开启品牌全球化增长之旅',
  
  cta_phone_title: '电话咨询',
  cta_phone_desc: '专业顾问一对一服务',
  cta_email_title: '邮件联系',
  cta_email_desc: '详细需求沟通',
  cta_wechat_title: '微信咨询',
  cta_wechat_desc: '即时沟通交流',

  // 关于我们页面
  about_title: '关于我们',
  about_subtitle: '专注全球达人整合营销，为品牌提供一站式营销解决方案',
  about_global_vision: '全球化视野',
  about_global_vision_desc: '覆盖全球50+国家地区',
  about_professional_team: '专业团队',
  about_professional_team_desc: '资深营销专家团队',
  about_excellent_results: '卓越成果',
  about_excellent_results_desc: '200+成功合作案例',
  
  // 愿景使命
  vision_mission_title: '公司愿景与使命',
  vision_mission_subtitle: 'Vision & Mission',
  our_vision: '我们的愿景',
  our_vision_desc: '成为全球领先的达人整合营销平台，连接世界各地的优质创作者与品牌，推动全球商业合作的创新发展。',
  our_mission: '我们的使命',
  our_mission_desc: '我们致力于通过"达人带货 + 广告投放 + 数据复盘"，为品牌提供一站式整合营销解决方案，帮助客户提升销量和影响力，快速进入全球市场。',
  
  // 定位
  positioning_title: '我们的定位',
  positioning_subtitle: 'Our Positioning',
  positioning_desc: '我们不仅是撮合平台，而是客户的长期营销伙伴，专注于效果导向与可执行的推广方案',
  long_term_partner: '长期营销伙伴',
  long_term_partner_desc: '我们不仅是撮合平台，更是客户的长期营销伙伴，与您共同成长',
  result_oriented: '效果导向',
  result_oriented_desc: '专注于可衡量的营销效果，每一分投入都要看到明确的回报',
  executable_solutions: '可执行方案',
  executable_solutions_desc: '提供切实可行的推广方案，从策略到执行，全程专业指导',
  professional_service: '专业服务',
  professional_service_desc: '资深营销专家团队，提供一对一专业咨询和全程服务支持',
  why_choose_us_partner: '为什么选择我们作为营销伙伴？',
  why_choose_us_partner_desc: '在竞争激烈的市场环境中，品牌需要的不仅仅是一次性的营销服务，而是能够持续创造价值的长期合作伙伴。我们深入了解每个客户的业务需求，制定个性化的营销策略，并通过数据驱动的方法持续优化效果，确保每一次合作都能为客户带来实实在在的商业价值。',
  
  // 里程碑
  milestones_title: '里程碑与数据',
  milestones_subtitle: 'Milestones & Numbers',
  milestones_desc: '用数据说话，用成果证明我们的专业实力',
  creator_partners: '达人签约/合作',
  creator_partners_en: 'Creator Partners',
  creator_partners_desc: '与全球200+优质达人建立深度合作关系',
  countries_regions: '覆盖国家与地区',
  countries_regions_en: 'Countries & Regions',
  countries_regions_desc: '业务覆盖全球50+国家和地区市场',
  response_time: '小时内项目响应',
  response_time_en: 'Hours Response Time',
  response_time_desc: '承诺24小时内响应客户项目需求',
  client_satisfaction: '客户满意度',
  client_satisfaction_en: 'Client Satisfaction',
  client_satisfaction_desc: '超过98%的客户对我们的服务表示满意',
  development_history: '发展历程',
  year_2023: '全球化布局',
  year_2023_desc: '业务拓展至50+国家，建立全球达人网络',
  year_2022: '技术升级',
  year_2022_desc: '推出数据分析平台，实现营销效果可视化',
  year_2021: '服务创新',
  year_2021_desc: '推出整合营销解决方案，一站式服务模式',
  year_2020: '公司成立',
  year_2020_desc: 'Koluno正式成立，专注达人营销服务',
  
  // CTA
  ready_to_start: '准备好开始了吗？',
  ready_to_start_en: 'Ready to get started?',
  ready_to_start_desc: '立即联系我们，获取定制化营销方案，开启品牌全球化增长之旅',
  contact_us: '联系我们',
  email_consultation: '邮件咨询',
  wechat_consultation: '微信咨询',

  // 达人招募页面
  apply_title: '加入我们的创作者联盟',
  apply_subtitle: '与全球顶级品牌合作，获得丰厚收益，实现创作价值最大化',
  apply_income: '月收入可达 $5000+',
  apply_brands: '与500+知名品牌合作',
  apply_support: '专业团队全程支持',
  apply_now: '立即申请加入',
  
  // 福利
  benefits_title: '为什么选择我们？',
  benefits_desc: '我们为创作者提供全方位的支持和资源，助您在内容创作道路上取得更大成功',
  rich_income: '丰厚收益',
  rich_income_desc: '根据粉丝量和互动率，月收入可达 $1000-$10000+，表现优秀者更有额外奖励',
  global_brands: '全球品牌资源',
  global_brands_desc: '与Nike、Apple、Samsung等500+国际知名品牌直接合作，获得独家产品和体验',
  professional_support: '专业团队支持',
  professional_support_desc: '配备专属经纪人、内容策划师和数据分析师，全方位提升创作效果',
  growth_opportunities: '成长机会',
  growth_opportunities_desc: '定期培训课程、行业峰会邀请，与顶级创作者交流学习，快速提升影响力',
  contract_protection: '合同保障',
  contract_protection_desc: '透明的合作条款，及时的费用结算，完善的法律保护，让您安心创作',
  data_insights: '数据洞察',
  data_insights_desc: '专业的数据分析报告，帮助您了解受众喜好，优化内容策略，提升变现效率',
  
  // 申请要求
  requirements_title: '申请要求',
  requirements_desc: '我们寻找有才华、有影响力的创作者加入我们的达人网络',
  basic_requirements: '基础要求',
  follower_requirements: '粉丝要求',
  content_quality: '内容质量',
  cooperation_attitude: '合作态度',
  tip_title: '温馨提示',
  tip_desc: '如果您暂时不满足某些要求，也欢迎申请！我们会根据您的潜力和特色进行综合评估，为有潜力的创作者提供成长支持和培训机会。',
  
  // 申请表单
  apply_form_title: '加入我们',
  apply_form_desc: '填写详细信息，让我们更好地了解您',
  or_contact_directly: '或直接联系我们',
  basic_info: '基础信息',
  platform_info: '平台信息',
  cooperation_preference: '合作偏好',
  contact_info: '联系方式',
  message_optional: '留言（可选）',
  privacy_agreement: '我已阅读并同意',
  privacy_policy: '隐私政策',
  terms_of_service: '服务条款',
  privacy_agreement_desc: '，并同意接收相关合作信息',
  submit_application: '提交申请',
  submitting: '提交中...',
  submit_success: '申请提交成功！我们会在24小时内与您联系。',
  submit_error: '提交失败，请稍后重试或直接联系我们。',
  
  // 通用按钮
  btn_contact_now: '立即联系',
  btn_learn_more: '了解更多',
  btn_get_started: '开始合作',
  
  // 联系方式
  contact_email: '邮箱',
  contact_telegram: 'Telegram',
  contact_wechat: '微信',
  contact_wechat_qr: '微信二维码',
  contact_wechat_id: '微信号',
  contact_scan_add: '扫码添加微信',
  contact_close: '关闭',
  contact_choose_method: '选择您喜欢的联系方式',
  
  // 页脚
  footer_quick_links: '快速链接',
  footer_services: '服务项目',
  footer_contact_info: '联系我们',
  footer_follow_us: '关注我们',
  footer_copyright: '版权所有',
  footer_all_rights_reserved: '版权所有',
  footer_privacy_policy: '隐私政策',
  footer_terms_of_service: '服务条款',
  footer_articles: '最新资讯',
  
  // 页脚服务项目
  footer_service_influencer: '达人营销',
  footer_service_advertising: '广告投放',
  footer_service_analytics: '数据分析',
  footer_service_strategy: '品牌策略',
  // 页面标题
  page_title_home: 'Koluno - 达人营销一站式解决方案',
  page_title_about: 'Koluno - 关于我们',
  page_title_apply: 'Koluno - 达人招募',
  page_title_privacy: 'Koluno - 隐私政策',
  page_title_terms: 'Koluno - 服务条款'
};

export default zhCommon;
